import React from 'react'

export const PrivacyPolicyTab: React.FC = () => {
  // TODO:JB - Implement this tab
  return <>Privacy Policy</>
}
